document.addEventListener('DOMContentLoaded', function() {
    var caseStories = document.querySelectorAll('.magazine-layover-block');
    var focusableElements = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';

    caseStories.forEach(function (caseStory) {
        var caseStoryOpener = caseStory.querySelector('.case-story__opener');
        var caseStoryModal = caseStory.querySelector('.case-story__modal');
        var caseStoryModalInner = caseStory.querySelector('.case-story__inner');
        var caseStoryClose = caseStory.querySelector('.case-story__close');

        caseStoryOpener.addEventListener('click', function () {
            var firstFocusableElement = caseStoryModal.querySelectorAll(focusableElements)[0];
            var focusableContent = caseStoryModal.querySelectorAll(focusableElements);
            var lastFocusableElement = focusableContent[focusableContent.length - 1];

            caseStoryModal.style.display = 'block';
            setTimeout(function () {
                caseStoryModal.classList.add('shown');
                document.body.classList.add('modal-open');
                firstFocusableElement.focus();
            }, 100);

            // trap focus to elements inside modal
            caseStoryModal.addEventListener('keydown', function(e) {
                var keyCode = e.keyCode;
                var isTabPressed = e.key === 'Tab' || keyCode === 9;

                if (keyCode === 27) {
                    caseStoryClose.click();
                } else {
                    if (!isTabPressed) {
                        return;
                    }

                    if (e.shiftKey) {
                        if (document.activeElement === firstFocusableElement) {
                            lastFocusableElement.focus();
                            e.preventDefault();
                        }
                    } else {
                        if (document.activeElement === lastFocusableElement) {
                            firstFocusableElement.focus();
                            e.preventDefault();
                        }
                    }
                }
            });
        });

        caseStoryClose.addEventListener('click', function () {
            closeModal();
        });

        caseStoryModal.addEventListener('click', function (e) {
            if (!caseStoryModalInner.contains(e.target)) {
                closeModal();
            }
        });

        function closeModal () {
            caseStoryModal.classList.remove('shown');
            document.body.classList.remove('modal-open');
            caseStoryOpener.focus();
            setTimeout(function () {
                caseStoryModal.style.display = 'none';
            }, 600);
        }
    });
});